import noassessmentTemplate from '../routes/assessments/noassessment.tpl.html';

angular.extend(window.config, {
  appId: 'assess',
  candidateApp: true,
  appPath: window.config.assessRoute,
  appName: 'Assess',

  // no intercom for the assess app
  intercomWidget: false,

  onResetReturn: false,
  onError: {
    template: noassessmentTemplate,
    msgBody() {
      return window.encodeURIComponent(`\
Hello,
I was unable to access my assessment using this link:
${window.location.toString()}
`);
    },
  },
});
